var map = {
	"./appShell/navigation.de.json": 60146,
	"./appShell/navigation.en.json": 7866,
	"./appShell/sidenavigation.de.json": 74199,
	"./appShell/sidenavigation.en.json": 6031,
	"./common/enums.de.json": 95442,
	"./common/enums.en.json": 43162,
	"./common/faq.de.json": 30963,
	"./common/faq.en.json": 99580,
	"./common/forms.de.json": 37353,
	"./common/forms.en.json": 85773,
	"./common/tagPickers.de.json": 60175,
	"./common/tagPickers.en.json": 98295,
	"./components/ControlledTagPicker.de.json": 97495,
	"./components/ControlledTagPicker.en.json": 46959,
	"./components/DocumentDetails/workflowDialog.de.json": 6062,
	"./components/DocumentDetails/workflowDialog.en.json": 80758,
	"./components/EntityList/ExcelExport.de.json": 82848,
	"./components/EntityList/ExcelExport.en.json": 82204,
	"./components/EntityList/RowWithContextualMenu.de.json": 19531,
	"./components/EntityList/RowWithContextualMenu.en.json": 6787,
	"./components/RequirementDetails/workflowDialog.de.json": 51316,
	"./components/RequirementDetails/workflowDialog.en.json": 71024,
	"./components/appendbutton.de.json": 40619,
	"./components/appendbutton.en.json": 23651,
	"./components/calloutloader.de.json": 85522,
	"./components/calloutloader.en.json": 70650,
	"./components/changehistory.de.json": 92483,
	"./components/changehistory.en.json": 65003,
	"./components/columnrenderers.de.json": 20637,
	"./components/columnrenderers.en.json": 18257,
	"./components/commentlist.de.json": 60408,
	"./components/commentlist.en.json": 79428,
	"./components/controlleddatepicker.de.json": 42763,
	"./components/controlleddatepicker.en.json": 42147,
	"./components/controlledfileupload.de.json": 59452,
	"./components/controlledfileupload.en.json": 22888,
	"./components/descriptionfield.de.json": 45409,
	"./components/descriptionfield.en.json": 71093,
	"./components/detailssection.de.json": 19104,
	"./components/detailssection.en.json": 34812,
	"./components/dialogs.de.json": 26588,
	"./components/dialogs.en.json": 90024,
	"./components/entitylist.de.json": 45690,
	"./components/entitylist.en.json": 73061,
	"./components/entitypage.de.json": 2575,
	"./components/entitypage.en.json": 81815,
	"./components/errormodal.de.json": 24450,
	"./components/errormodal.en.json": 28426,
	"./components/faq.de.json": 94575,
	"./components/faq.en.json": 90167,
	"./components/faqlist.de.json": 28259,
	"./components/faqlist.en.json": 44747,
	"./components/infinitylist.de.json": 20899,
	"./components/infinitylist.en.json": 19723,
	"./components/keywords.de.json": 63091,
	"./components/keywords.en.json": 97243,
	"./components/loadwrapper.de.json": 49610,
	"./components/loadwrapper.en.json": 73730,
	"./components/marketnamingtemplatevalidation.de.json": 93064,
	"./components/marketnamingtemplatevalidation.en.json": 17236,
	"./components/namingtemplatefield.de.json": 66377,
	"./components/namingtemplatefield.en.json": 14797,
	"./components/notificationbar.de.json": 2051,
	"./components/notificationbar.en.json": 58219,
	"./components/peoplepicker.de.json": 37100,
	"./components/peoplepicker.en.json": 17272,
	"./components/persona.de.json": 2759,
	"./components/persona.en.json": 35487,
	"./components/phasepicker.de.json": 89796,
	"./components/phasepicker.en.json": 33536,
	"./components/referencepicker.de.json": 98266,
	"./components/referencepicker.en.json": 64370,
	"./components/textsearchbar.de.json": 95999,
	"./components/textsearchbar.en.json": 68807,
	"./components/translationfield.de.json": 6408,
	"./components/translationfield.en.json": 62644,
	"./components/usersettings.de.json": 37009,
	"./components/usersettings.en.json": 53701,
	"./features/AdminSection/adminReferencePage.de.json": 69530,
	"./features/AdminSection/adminReferencePage.en.json": 16274,
	"./features/Archive/regulatoryDocumentArchivePage.de.json": 99585,
	"./features/Archive/regulatoryDocumentArchivePage.en.json": 25269,
	"./features/GetexRegulation/getexParagraphs.de.json": 79034,
	"./features/GetexRegulation/getexParagraphs.en.json": 25778,
	"./features/RegDocs/compareVersionForm.de.json": 84695,
	"./features/RegDocs/compareVersionForm.en.json": 75407,
	"./features/RegDocs/compareVersionPanel.de.json": 98415,
	"./features/RegDocs/compareVersionPanel.en.json": 77655,
	"./features/RegDocs/keywordAssignmentForm.de.json": 98044,
	"./features/RegDocs/keywordAssignmentForm.en.json": 4552,
	"./features/RegDocs/regDocParagraphs.de.json": 81927,
	"./features/RegDocs/regDocParagraphs.en.json": 45599,
	"./features/RegDocs/regDocsList.de.json": 41735,
	"./features/RegDocs/regDocsList.en.json": 5407,
	"./features/Reports/reportsList.de.json": 70691,
	"./features/Reports/reportsList.en.json": 21835,
	"./features/Simulations/simulationDetailsPage.de.json": 29503,
	"./features/Simulations/simulationDetailsPage.en.json": 2311,
	"./features/Simulations/simulations.de.json": 98963,
	"./features/Simulations/simulations.en.json": 10043,
	"./features/Simulations/simulationsPage.de.json": 49298,
	"./features/Simulations/simulationsPage.en.json": 82618,
	"./features/VehicleProjects/activeTypeMarketDetailsPage.de.json": 36828,
	"./features/VehicleProjects/activeTypeMarketDetailsPage.en.json": 37448,
	"./features/VehicleProjects/activeTypeMarketsPage.de.json": 77209,
	"./features/VehicleProjects/activeTypeMarketsPage.en.json": 35869,
	"./features/VehicleProjects/assignVehicleProjectRequirementsForm.de.json": 31779,
	"./features/VehicleProjects/assignVehicleProjectRequirementsForm.en.json": 4299,
	"./features/VehicleProjects/baselineChanges.de.json": 42713,
	"./features/VehicleProjects/baselineChanges.en.json": 73245,
	"./features/VehicleProjects/baselineDetailsPage.de.json": 42173,
	"./features/VehicleProjects/baselineDetailsPage.en.json": 78417,
	"./features/VehicleProjects/baselines.de.json": 9381,
	"./features/VehicleProjects/baselines.en.json": 58857,
	"./features/VehicleProjects/baselinesPage.de.json": 39568,
	"./features/VehicleProjects/baselinesPage.en.json": 72940,
	"./features/VehicleProjects/permissionsForm.de.json": 26431,
	"./features/VehicleProjects/permissionsForm.en.json": 99239,
	"./features/VehicleProjects/requirementsList.de.json": 9153,
	"./features/VehicleProjects/requirementsList.en.json": 34837,
	"./features/adminsection.de.json": 19246,
	"./features/adminsection.en.json": 90838,
	"./features/archive.de.json": 78288,
	"./features/archive.en.json": 89279,
	"./features/copilotintegration.de.json": 74938,
	"./features/copilotintegration.en.json": 24690,
	"./features/dashboard.de.json": 92894,
	"./features/dashboard.en.json": 31654,
	"./features/getexregulation.de.json": 85629,
	"./features/getexregulation.en.json": 21873,
	"./features/globalannouncements.de.json": 24113,
	"./features/globalannouncements.en.json": 24453,
	"./features/headlessregulatorydocuments.de.json": 31329,
	"./features/headlessregulatorydocuments.en.json": 11829,
	"./features/jsonImportExport.de.json": 91623,
	"./features/jsonImportExport.en.json": 55295,
	"./features/localizedTooltips/activeTypeMarkets.de.json": 13549,
	"./features/localizedTooltips/activeTypeMarkets.en.json": 51521,
	"./features/localizedTooltips/assignedRequirements.de.json": 75786,
	"./features/localizedTooltips/assignedRequirements.en.json": 78210,
	"./features/localizedTooltips/attachmentCategories.de.json": 6713,
	"./features/localizedTooltips/attachmentCategories.en.json": 37245,
	"./features/localizedTooltips/attachments.de.json": 49554,
	"./features/localizedTooltips/attachments.en.json": 66522,
	"./features/localizedTooltips/bodyworkVariants.de.json": 61031,
	"./features/localizedTooltips/bodyworkVariants.en.json": 17375,
	"./features/localizedTooltips/categories.de.json": 35910,
	"./features/localizedTooltips/categories.en.json": 97726,
	"./features/localizedTooltips/convolutes.de.json": 56354,
	"./features/localizedTooltips/convolutes.en.json": 72330,
	"./features/localizedTooltips/countries.de.json": 25350,
	"./features/localizedTooltips/countries.en.json": 23806,
	"./features/localizedTooltips/documentReferences.de.json": 90751,
	"./features/localizedTooltips/documentReferences.en.json": 11975,
	"./features/localizedTooltips/documentSources.de.json": 99335,
	"./features/localizedTooltips/documentSources.en.json": 32063,
	"./features/localizedTooltips/driveVariants.de.json": 62946,
	"./features/localizedTooltips/driveVariants.en.json": 6570,
	"./features/localizedTooltips/engineVariants.de.json": 28838,
	"./features/localizedTooltips/engineVariants.en.json": 7006,
	"./features/localizedTooltips/gdrpRules.de.json": 60344,
	"./features/localizedTooltips/gdrpRules.en.json": 64964,
	"./features/localizedTooltips/gearboxVariants.de.json": 91830,
	"./features/localizedTooltips/gearboxVariants.en.json": 40110,
	"./features/localizedTooltips/globalAnnouncements.de.json": 54235,
	"./features/localizedTooltips/globalAnnouncements.en.json": 34803,
	"./features/localizedTooltips/keywords.de.json": 32094,
	"./features/localizedTooltips/keywords.en.json": 76358,
	"./features/localizedTooltips/markets.de.json": 76807,
	"./features/localizedTooltips/markets.en.json": 36255,
	"./features/localizedTooltips/notifications.de.json": 60740,
	"./features/localizedTooltips/notifications.en.json": 73728,
	"./features/localizedTooltips/pcmsClusters.de.json": 69960,
	"./features/localizedTooltips/pcmsClusters.en.json": 60372,
	"./features/localizedTooltips/permissions.de.json": 30704,
	"./features/localizedTooltips/permissions.en.json": 64076,
	"./features/localizedTooltips/references.de.json": 46856,
	"./features/localizedTooltips/references.en.json": 71028,
	"./features/localizedTooltips/regulationClusters.de.json": 18023,
	"./features/localizedTooltips/regulationClusters.en.json": 93823,
	"./features/localizedTooltips/systemLevels.de.json": 1040,
	"./features/localizedTooltips/systemLevels.en.json": 12396,
	"./features/localizedTooltips/tags.de.json": 58765,
	"./features/localizedTooltips/tags.en.json": 96737,
	"./features/localizedTooltips/vehicleCategories.de.json": 13200,
	"./features/localizedTooltips/vehicleCategories.en.json": 40908,
	"./features/localizedTooltips/vexClusters.de.json": 29068,
	"./features/localizedTooltips/vexClusters.en.json": 96120,
	"./features/localizedTooltips/vkos.de.json": 47413,
	"./features/localizedTooltips/vkos.en.json": 80153,
	"./features/localizedTooltips/workflows.de.json": 85218,
	"./features/localizedTooltips/workflows.en.json": 55242,
	"./features/matkon.de.json": 43046,
	"./features/matkon.en.json": 41502,
	"./features/pogisdocuments.de.json": 28652,
	"./features/pogisdocuments.en.json": 79352,
	"./features/recents.de.json": 55202,
	"./features/recents.en.json": 71178,
	"./features/regulations.de.json": 27945,
	"./features/regulations.en.json": 33837,
	"./features/regulatorydocuments.de.json": 28554,
	"./features/regulatorydocuments.en.json": 52674,
	"./features/reports.de.json": 32363,
	"./features/reports.en.json": 15395,
	"./features/requirements.de.json": 62020,
	"./features/requirements.en.json": 60768,
	"./features/search.de.json": 90064,
	"./features/search.en.json": 82188,
	"./features/subscriptions.de.json": 10604,
	"./features/subscriptions.en.json": 49528,
	"./features/vehicleprojects.de.json": 44736,
	"./features/vehicleprojects.en.json": 60444,
	"./hooks/useEditEntityCmd.de.json": 35605,
	"./hooks/useEditEntityCmd.en.json": 98969,
	"./hooks/useFavoriteCommand.de.json": 63245,
	"./hooks/useFavoriteCommand.en.json": 61569,
	"./hooks/useToggleAuditCmd.de.json": 1383,
	"./hooks/useToggleAuditCmd.en.json": 34111,
	"locales/appShell/navigation.de.json": 60146,
	"locales/appShell/navigation.en.json": 7866,
	"locales/appShell/sidenavigation.de.json": 74199,
	"locales/appShell/sidenavigation.en.json": 6031,
	"locales/common/enums.de.json": 95442,
	"locales/common/enums.en.json": 43162,
	"locales/common/faq.de.json": 30963,
	"locales/common/faq.en.json": 99580,
	"locales/common/forms.de.json": 37353,
	"locales/common/forms.en.json": 85773,
	"locales/common/tagPickers.de.json": 60175,
	"locales/common/tagPickers.en.json": 98295,
	"locales/components/ControlledTagPicker.de.json": 97495,
	"locales/components/ControlledTagPicker.en.json": 46959,
	"locales/components/DocumentDetails/workflowDialog.de.json": 6062,
	"locales/components/DocumentDetails/workflowDialog.en.json": 80758,
	"locales/components/EntityList/ExcelExport.de.json": 82848,
	"locales/components/EntityList/ExcelExport.en.json": 82204,
	"locales/components/EntityList/RowWithContextualMenu.de.json": 19531,
	"locales/components/EntityList/RowWithContextualMenu.en.json": 6787,
	"locales/components/RequirementDetails/workflowDialog.de.json": 51316,
	"locales/components/RequirementDetails/workflowDialog.en.json": 71024,
	"locales/components/appendbutton.de.json": 40619,
	"locales/components/appendbutton.en.json": 23651,
	"locales/components/calloutloader.de.json": 85522,
	"locales/components/calloutloader.en.json": 70650,
	"locales/components/changehistory.de.json": 92483,
	"locales/components/changehistory.en.json": 65003,
	"locales/components/columnrenderers.de.json": 20637,
	"locales/components/columnrenderers.en.json": 18257,
	"locales/components/commentlist.de.json": 60408,
	"locales/components/commentlist.en.json": 79428,
	"locales/components/controlleddatepicker.de.json": 42763,
	"locales/components/controlleddatepicker.en.json": 42147,
	"locales/components/controlledfileupload.de.json": 59452,
	"locales/components/controlledfileupload.en.json": 22888,
	"locales/components/descriptionfield.de.json": 45409,
	"locales/components/descriptionfield.en.json": 71093,
	"locales/components/detailssection.de.json": 19104,
	"locales/components/detailssection.en.json": 34812,
	"locales/components/dialogs.de.json": 26588,
	"locales/components/dialogs.en.json": 90024,
	"locales/components/entitylist.de.json": 45690,
	"locales/components/entitylist.en.json": 73061,
	"locales/components/entitypage.de.json": 2575,
	"locales/components/entitypage.en.json": 81815,
	"locales/components/errormodal.de.json": 24450,
	"locales/components/errormodal.en.json": 28426,
	"locales/components/faq.de.json": 94575,
	"locales/components/faq.en.json": 90167,
	"locales/components/faqlist.de.json": 28259,
	"locales/components/faqlist.en.json": 44747,
	"locales/components/infinitylist.de.json": 20899,
	"locales/components/infinitylist.en.json": 19723,
	"locales/components/keywords.de.json": 63091,
	"locales/components/keywords.en.json": 97243,
	"locales/components/loadwrapper.de.json": 49610,
	"locales/components/loadwrapper.en.json": 73730,
	"locales/components/marketnamingtemplatevalidation.de.json": 93064,
	"locales/components/marketnamingtemplatevalidation.en.json": 17236,
	"locales/components/namingtemplatefield.de.json": 66377,
	"locales/components/namingtemplatefield.en.json": 14797,
	"locales/components/notificationbar.de.json": 2051,
	"locales/components/notificationbar.en.json": 58219,
	"locales/components/peoplepicker.de.json": 37100,
	"locales/components/peoplepicker.en.json": 17272,
	"locales/components/persona.de.json": 2759,
	"locales/components/persona.en.json": 35487,
	"locales/components/phasepicker.de.json": 89796,
	"locales/components/phasepicker.en.json": 33536,
	"locales/components/referencepicker.de.json": 98266,
	"locales/components/referencepicker.en.json": 64370,
	"locales/components/textsearchbar.de.json": 95999,
	"locales/components/textsearchbar.en.json": 68807,
	"locales/components/translationfield.de.json": 6408,
	"locales/components/translationfield.en.json": 62644,
	"locales/components/usersettings.de.json": 37009,
	"locales/components/usersettings.en.json": 53701,
	"locales/features/AdminSection/adminReferencePage.de.json": 69530,
	"locales/features/AdminSection/adminReferencePage.en.json": 16274,
	"locales/features/Archive/regulatoryDocumentArchivePage.de.json": 99585,
	"locales/features/Archive/regulatoryDocumentArchivePage.en.json": 25269,
	"locales/features/GetexRegulation/getexParagraphs.de.json": 79034,
	"locales/features/GetexRegulation/getexParagraphs.en.json": 25778,
	"locales/features/RegDocs/compareVersionForm.de.json": 84695,
	"locales/features/RegDocs/compareVersionForm.en.json": 75407,
	"locales/features/RegDocs/compareVersionPanel.de.json": 98415,
	"locales/features/RegDocs/compareVersionPanel.en.json": 77655,
	"locales/features/RegDocs/keywordAssignmentForm.de.json": 98044,
	"locales/features/RegDocs/keywordAssignmentForm.en.json": 4552,
	"locales/features/RegDocs/regDocParagraphs.de.json": 81927,
	"locales/features/RegDocs/regDocParagraphs.en.json": 45599,
	"locales/features/RegDocs/regDocsList.de.json": 41735,
	"locales/features/RegDocs/regDocsList.en.json": 5407,
	"locales/features/Reports/reportsList.de.json": 70691,
	"locales/features/Reports/reportsList.en.json": 21835,
	"locales/features/Simulations/simulationDetailsPage.de.json": 29503,
	"locales/features/Simulations/simulationDetailsPage.en.json": 2311,
	"locales/features/Simulations/simulations.de.json": 98963,
	"locales/features/Simulations/simulations.en.json": 10043,
	"locales/features/Simulations/simulationsPage.de.json": 49298,
	"locales/features/Simulations/simulationsPage.en.json": 82618,
	"locales/features/VehicleProjects/activeTypeMarketDetailsPage.de.json": 36828,
	"locales/features/VehicleProjects/activeTypeMarketDetailsPage.en.json": 37448,
	"locales/features/VehicleProjects/activeTypeMarketsPage.de.json": 77209,
	"locales/features/VehicleProjects/activeTypeMarketsPage.en.json": 35869,
	"locales/features/VehicleProjects/assignVehicleProjectRequirementsForm.de.json": 31779,
	"locales/features/VehicleProjects/assignVehicleProjectRequirementsForm.en.json": 4299,
	"locales/features/VehicleProjects/baselineChanges.de.json": 42713,
	"locales/features/VehicleProjects/baselineChanges.en.json": 73245,
	"locales/features/VehicleProjects/baselineDetailsPage.de.json": 42173,
	"locales/features/VehicleProjects/baselineDetailsPage.en.json": 78417,
	"locales/features/VehicleProjects/baselines.de.json": 9381,
	"locales/features/VehicleProjects/baselines.en.json": 58857,
	"locales/features/VehicleProjects/baselinesPage.de.json": 39568,
	"locales/features/VehicleProjects/baselinesPage.en.json": 72940,
	"locales/features/VehicleProjects/permissionsForm.de.json": 26431,
	"locales/features/VehicleProjects/permissionsForm.en.json": 99239,
	"locales/features/VehicleProjects/requirementsList.de.json": 9153,
	"locales/features/VehicleProjects/requirementsList.en.json": 34837,
	"locales/features/adminsection.de.json": 19246,
	"locales/features/adminsection.en.json": 90838,
	"locales/features/archive.de.json": 78288,
	"locales/features/archive.en.json": 89279,
	"locales/features/copilotintegration.de.json": 74938,
	"locales/features/copilotintegration.en.json": 24690,
	"locales/features/dashboard.de.json": 92894,
	"locales/features/dashboard.en.json": 31654,
	"locales/features/getexregulation.de.json": 85629,
	"locales/features/getexregulation.en.json": 21873,
	"locales/features/globalannouncements.de.json": 24113,
	"locales/features/globalannouncements.en.json": 24453,
	"locales/features/headlessregulatorydocuments.de.json": 31329,
	"locales/features/headlessregulatorydocuments.en.json": 11829,
	"locales/features/jsonImportExport.de.json": 91623,
	"locales/features/jsonImportExport.en.json": 55295,
	"locales/features/localizedTooltips/activeTypeMarkets.de.json": 13549,
	"locales/features/localizedTooltips/activeTypeMarkets.en.json": 51521,
	"locales/features/localizedTooltips/assignedRequirements.de.json": 75786,
	"locales/features/localizedTooltips/assignedRequirements.en.json": 78210,
	"locales/features/localizedTooltips/attachmentCategories.de.json": 6713,
	"locales/features/localizedTooltips/attachmentCategories.en.json": 37245,
	"locales/features/localizedTooltips/attachments.de.json": 49554,
	"locales/features/localizedTooltips/attachments.en.json": 66522,
	"locales/features/localizedTooltips/bodyworkVariants.de.json": 61031,
	"locales/features/localizedTooltips/bodyworkVariants.en.json": 17375,
	"locales/features/localizedTooltips/categories.de.json": 35910,
	"locales/features/localizedTooltips/categories.en.json": 97726,
	"locales/features/localizedTooltips/convolutes.de.json": 56354,
	"locales/features/localizedTooltips/convolutes.en.json": 72330,
	"locales/features/localizedTooltips/countries.de.json": 25350,
	"locales/features/localizedTooltips/countries.en.json": 23806,
	"locales/features/localizedTooltips/documentReferences.de.json": 90751,
	"locales/features/localizedTooltips/documentReferences.en.json": 11975,
	"locales/features/localizedTooltips/documentSources.de.json": 99335,
	"locales/features/localizedTooltips/documentSources.en.json": 32063,
	"locales/features/localizedTooltips/driveVariants.de.json": 62946,
	"locales/features/localizedTooltips/driveVariants.en.json": 6570,
	"locales/features/localizedTooltips/engineVariants.de.json": 28838,
	"locales/features/localizedTooltips/engineVariants.en.json": 7006,
	"locales/features/localizedTooltips/gdrpRules.de.json": 60344,
	"locales/features/localizedTooltips/gdrpRules.en.json": 64964,
	"locales/features/localizedTooltips/gearboxVariants.de.json": 91830,
	"locales/features/localizedTooltips/gearboxVariants.en.json": 40110,
	"locales/features/localizedTooltips/globalAnnouncements.de.json": 54235,
	"locales/features/localizedTooltips/globalAnnouncements.en.json": 34803,
	"locales/features/localizedTooltips/keywords.de.json": 32094,
	"locales/features/localizedTooltips/keywords.en.json": 76358,
	"locales/features/localizedTooltips/markets.de.json": 76807,
	"locales/features/localizedTooltips/markets.en.json": 36255,
	"locales/features/localizedTooltips/notifications.de.json": 60740,
	"locales/features/localizedTooltips/notifications.en.json": 73728,
	"locales/features/localizedTooltips/pcmsClusters.de.json": 69960,
	"locales/features/localizedTooltips/pcmsClusters.en.json": 60372,
	"locales/features/localizedTooltips/permissions.de.json": 30704,
	"locales/features/localizedTooltips/permissions.en.json": 64076,
	"locales/features/localizedTooltips/references.de.json": 46856,
	"locales/features/localizedTooltips/references.en.json": 71028,
	"locales/features/localizedTooltips/regulationClusters.de.json": 18023,
	"locales/features/localizedTooltips/regulationClusters.en.json": 93823,
	"locales/features/localizedTooltips/systemLevels.de.json": 1040,
	"locales/features/localizedTooltips/systemLevels.en.json": 12396,
	"locales/features/localizedTooltips/tags.de.json": 58765,
	"locales/features/localizedTooltips/tags.en.json": 96737,
	"locales/features/localizedTooltips/vehicleCategories.de.json": 13200,
	"locales/features/localizedTooltips/vehicleCategories.en.json": 40908,
	"locales/features/localizedTooltips/vexClusters.de.json": 29068,
	"locales/features/localizedTooltips/vexClusters.en.json": 96120,
	"locales/features/localizedTooltips/vkos.de.json": 47413,
	"locales/features/localizedTooltips/vkos.en.json": 80153,
	"locales/features/localizedTooltips/workflows.de.json": 85218,
	"locales/features/localizedTooltips/workflows.en.json": 55242,
	"locales/features/matkon.de.json": 43046,
	"locales/features/matkon.en.json": 41502,
	"locales/features/pogisdocuments.de.json": 28652,
	"locales/features/pogisdocuments.en.json": 79352,
	"locales/features/recents.de.json": 55202,
	"locales/features/recents.en.json": 71178,
	"locales/features/regulations.de.json": 27945,
	"locales/features/regulations.en.json": 33837,
	"locales/features/regulatorydocuments.de.json": 28554,
	"locales/features/regulatorydocuments.en.json": 52674,
	"locales/features/reports.de.json": 32363,
	"locales/features/reports.en.json": 15395,
	"locales/features/requirements.de.json": 62020,
	"locales/features/requirements.en.json": 60768,
	"locales/features/search.de.json": 90064,
	"locales/features/search.en.json": 82188,
	"locales/features/subscriptions.de.json": 10604,
	"locales/features/subscriptions.en.json": 49528,
	"locales/features/vehicleprojects.de.json": 44736,
	"locales/features/vehicleprojects.en.json": 60444,
	"locales/hooks/useEditEntityCmd.de.json": 35605,
	"locales/hooks/useEditEntityCmd.en.json": 98969,
	"locales/hooks/useFavoriteCommand.de.json": 63245,
	"locales/hooks/useFavoriteCommand.en.json": 61569,
	"locales/hooks/useToggleAuditCmd.de.json": 1383,
	"locales/hooks/useToggleAuditCmd.en.json": 34111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3901;